import { render, staticRenderFns } from "./navbarPrincipal.vue?vue&type=template&id=4eab10d4&"
import script from "./navbarPrincipal.vue?vue&type=script&lang=js&"
export * from "./navbarPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports